// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qualification-step-root[data-v-057f0fc5] {\n  padding-top: 48px;\n  padding-bottom: 40px;\n  box-sizing: border-box;\n}\n.qualification-step-root .content[data-v-057f0fc5] {\n  padding: 0;\n  box-sizing: border-box;\n  margin-top: 40px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 1012px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
